module.exports = __webpack_public_path__ + "src/assets/img/rampantcrime1.5360d731.jpg";